import Vue from 'vue';
import mixpanel from 'mixpanel-browser';

mixpanel.init('627eff03116ab624d59c4e9779ad2f42');

Vue.prototype.$mixpanel = mixpanel;
